export default __webpack_public_path__ + "CFs_SMS.html";